function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Table, Container, Row, Col } from "react-bootstrap";
import { Skeleton, Tag } from "antd";
import Common from "../../components/includes/Common";
import Moment from "react-moment";
import { HourglassSplit, Stopwatch, CheckCircleFill, XCircleFill } from 'react-bootstrap-icons';
import moment from 'moment';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Transactions = function Transactions() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    transactions = _useState2[0],
    setTransactions = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setIsDataLoading = _useState6[1];
  var _useState7 = useState(moment().startOf('month').format()),
    _useState8 = _slicedToArray(_useState7, 2),
    from = _useState8[0],
    setFrom = _useState8[1];
  var _useState9 = useState(moment().endOf('month').format()),
    _useState10 = _slicedToArray(_useState9, 2),
    to = _useState10[0],
    setTo = _useState10[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get("".concat(Common.baseApiUrl, "gettransactions/").concat(Common.currentUser.id, "/").concat(from, "/").concat(to)).then(function (response) {
      if (response.data.status == 200) setTransactions(response.data.transactions);else setErrorMessage(response.data.message);
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue, verifiez votre connexion internet");
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Tag, {
            color: "#7A3C55",
            style: {
              margin: "7px 0px"
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "Historique transactions"
            })
          })
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 8,
          md: 8,
          sm: 10,
          children: [/*#__PURE__*/_jsxs(Table, {
            striped: true,
            bordered: true,
            hover: true,
            responsive: true,
            children: [/*#__PURE__*/_jsx("thead", {
              children: /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("th", {
                  children: "#ID"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Date"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Montant"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Status"
                })]
              })
            }), /*#__PURE__*/_jsx("tbody", {
              children: transactions.map(function (t) {
                return /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: t.id
                  }), /*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(Moment, {
                        date: t.created_at,
                        format: "DD/MM/YYYY HH:mm"
                      })
                    })
                  }), /*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsxs("b", {
                      children: [t.amount.toLocaleString("Fr"), " GNF"]
                    })
                  }), /*#__PURE__*/_jsxs("td", {
                    children: [t.status == 0 && /*#__PURE__*/_jsx(Tag, {
                      color: "#CEA347",
                      icon: /*#__PURE__*/_jsx(HourglassSplit, {}),
                      children: " En attente"
                    }), t.status == 1 && /*#__PURE__*/_jsx(Tag, {
                      color: "#488D59",
                      icon: /*#__PURE__*/_jsx(CheckCircleFill, {}),
                      children: " R\xE9ussie"
                    }), t.status == 2 && /*#__PURE__*/_jsx(Tag, {
                      color: "#8D3535",
                      icon: /*#__PURE__*/_jsx(XCircleFill, {}),
                      children: " Annul\xE9e"
                    }), t.status == 3 && /*#__PURE__*/_jsx(Tag, {
                      color: "#5C338D",
                      icon: /*#__PURE__*/_jsx(Stopwatch, {}),
                      children: " Expir\xE9e"
                    })]
                  })]
                }, t.id);
              })
            })]
          }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
            active: true
          })]
        })
      })]
    })]
  });
};
export default Transactions;